import React from "react";
import "./BlogList.css";
import blog1 from "../../media/bannerimg.jpg"; // Replace with real image paths
import blog2 from "../../media/bannerimg.jpg";
import blog3 from "../../media/bannerimg.jpg";
import PageBanner from "../components/PageBanner";
import bannerimg from "../../media/bannerimg.jpg";
const blogs = [
  {
    id: 1,
    title: "10 Common Financial Mistakes Small Businesses",
    image: blog1,
    author: "RRDevs",
    date: "August 12, 2024",
  },
  {
    id: 2,
    title: "How To Optimize Your Business Budget",
    image: blog2,
    author: "RRDevs",
    date: "August 12, 2024",
  },
  {
    id: 3,
    title: "Why Financial Forecasting Is Key To",
    image: blog3,
    author: "RRDevs",
    date: "August 12, 2024",
  },
];

const BlogList = () => {
  return (
    <div className="outer-blog">
      <PageBanner title="Blog" breadcrumb="Blog" bgImage={bannerimg} />
      <section className="bloglist-section py-5">
        <div className="container">
          <div className="row">
            {blogs.map((blog) => (
              <div className="col-md-4 mb-4" key={blog.id}>
                <div className="bloglist-card">
                  <img
                    src={blog.image}
                    alt={blog.title}
                    className="bloglist-image"
                  />
                  <div className="bloglist-body">
                    <div className="bloglist-meta mb-2">
                      <span className="bloglist-date">📅 {blog.date}</span>
                      <span className="bloglist-author ms-3">
                        👤 By {blog.author}
                      </span>
                    </div>
                    <h5 className="bloglist-title">{blog.title}</h5>

                    <div className="bloglist-readmore-wrapper mt-auto">
                      <div className="bloglist-readmore-line"></div>
                      <span className="bloglist-readmore">
                        READ MORE <span className="bloglist-arrow">»</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogList;
